<template>
    <div class="container content-space-t-1 d-flex justify-content-center">
        <div class="w-lg-75">
            <div class="info-box bg-secondary text-light p-5 rounded">
                <h2 class="text-white">{{ $translate('card_requirement', '{title} krav').replace('{title}', document.data.title) }}</h2>
                <ul>
                    <li v-for="(req, index) in reqs" :key="`req${index}`">{{ req }}</li>
                </ul>
                <out-link :document="document" class="btn btn-light text-dark fw-bold" placement="requirements" />
            </div>

            <div class="rich-text mb-4" v-html="$prismic.asHtml(document.data.content)" />

            <opening-hours :model="model" />
            <company-facts :model="model" />
        </div>
    </div>
</template>
<script>
import OpeningHours from '@/components/models/OpeningHours.vue';
import CompanyFacts from '@/components/models/CompanyFacts.vue';
export default {
    components: {
        OpeningHours,
        CompanyFacts
    },
    props: {
        document: {
            type: Object,
            required: true
        },
        model: {
            type: Object,
            required: true
        }
    },
    computed: {
        reqs() {
            let reqs = [];

            reqs.push(
                this.$translate('min_age_demand', 'Minst {age} år')
                    .replace('{age}', this.model.minAge)
            );

            if (! this.model.acceptsNoIncome) {
                if (this.model.minimumYearlyIncome > 0) {
                    reqs.push(
                        this.$translate('min_monthly_income_demand', 'Månadsinkomst över {amount}')
                            .replace('{amount}', this.$format.currency(this.model.minimumYearlyIncome / 12))
                    );
                }
                else {
                    reqs.push(this.$translate('full_time_employment_demand', 'Heltidsanställning'));
                }
            }

            if (! this.model.acceptsPaymentRemarks) {
                reqs.push(this.$translate('no_payment_remarks_demand', 'Inga betalningsanmärkningar'));
            }
            else {
                reqs.push(this.$translate('accepts_payment_remarks', 'Betalningsanmärkningar accepteras'));
            }

            return reqs;
        }
    }
};
</script>